import { cssVar } from '@chakra-ui/react';

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');

const baseStyleTrack = () => {
  return {
    borderRadius: 'full',
    p: '2px',
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: 'common',
    transitionDuration: 'fast',
    // Same as the design-system (kula) Switch in both themes: the off track is
    // the theme's secondary-300, the on track the brand fill.
    bg: 'var(--kula-colors-secondary-300)',
    _focus: {
      boxShadow: 'none',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _checked: {
      bg: 'var(--kula-dark-brand-fill, var(--kula-colors-primary-500))',
    },
  };
};

const baseStyle = (props) => ({
  track: baseStyleTrack(props),
  // Chakra's default thumb is `white`, which dark mode turns into the dark
  // surface; the thumb stays white in both themes.
  thumb: { bg: 'static-white' },
});

const sizes = {
  md: {
    container: {
      [$width.variable]: '30px',
      [$height.variable]: '14px',
    },
  },
};

const defaultProps = {
  size: 'md',
};

export const Switch = {
  baseStyle,
  sizes,
  defaultProps,
};
